import { CdkDrag, CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WidgetsContainerComponentAbstract } from 'src/app/abstract/widgets/widgets-container-component.abstract';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { Logger } from 'src/app/core/logger';
import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { ValdnWidgetsComparisonModel } from 'src/app/models/widgets-validation/valdn-widgets-comparison.model';
import { ValdnWidgetsDateModel } from 'src/app/models/widgets-validation/valdn-widgets-date.model';
import { ValdnWidgetsIPModel } from 'src/app/models/widgets-validation/valdn-widgets-ip.model';
import { ValdnWidgetsTimeRangeModel } from 'src/app/models/widgets-validation/valdn-widgets-time-range.model';
import { WidgetsInputModel } from 'src/app/models/widgets/widgets-input.model';
import { WidgetsMetadataService } from 'src/app/services/widgets/widgets-metadata.service';
import { WidgetsNotifyDeleteService } from 'src/app/services/widgets/widgets-notify-delete.service';
import { WidgetsSelectionService } from 'src/app/services/widgets/widgets-selection.service';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';

@Component({
  selector: '[appWidgetsInput]',
  templateUrl: './widgets-input.component.html',
  styleUrls: ['./widgets-input.component.scss'],
})
export class WidgetsInputComponent
  extends WidgetsContainerComponentAbstract
  implements OnInit
{
  @Input() data: WidgetsInputModel = new WidgetsInputModel();
  @Input() dropListIds: string[] = [];
  @Output() dropListIdAdded: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private widgetsService: WidgetsService,
    private selectionService: WidgetsSelectionService,
    private widgetsMetadataService: WidgetsMetadataService,
    private notifyDeleteService: WidgetsNotifyDeleteService,
    private logger: Logger
  ) {
    super();
  }

  ngOnInit(): void {}

  onWidgetDroppedToCanvas(
    event: CdkDragDrop<WidgetsAbstract[], WidgetsAbstract[], any>
  ): WidgetsAbstract {
    switch (event.item.data.widgetType) {
      case WidgetsTypeEnum.VALDN_COMP:
        // Pending: return model for specific validation
        return new ValdnWidgetsComparisonModel();
      case WidgetsTypeEnum.VALDN_DATE:
        return new ValdnWidgetsDateModel();
      case WidgetsTypeEnum.VALDN_IP:
        return new ValdnWidgetsIPModel();
      case WidgetsTypeEnum.VALDN_TIMERANGE:
        return new ValdnWidgetsTimeRangeModel();
    }
    return {} as WidgetsAbstract;
  }

  isDroppableWidget(item: CdkDrag<WidgetsAbstract>) {
    switch (item.data.widgetType) {
      case WidgetsTypeEnum.VALDN_COMP:
      case WidgetsTypeEnum.VALDN_DATE:
      case WidgetsTypeEnum.VALDN_IP:
        return true;
    }

    return false;
  }

  onDeleteModal(): void {
    this.notifyDeleteService.notifyDelete(this.data);
  }

  onDebug() {
    // console.log('debug');
  }

  clone(orgWidget: WidgetsInputModel): WidgetsAbstract {
    const newInput = new WidgetsInputModel();
    newInput.cloneFrom(orgWidget);
    return newInput;
  }

  onWidgetsReordered(culprits: WidgetsAbstract[]) {
    throw new Error('Method not implemented.');
  }
  onSelect($event) {
    this.selectionService.toggleSelection(this.data);
  }
}
